import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { FooterContactComponent } from './components/footer-contact/footer-contact.component';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    BrowserAnimationsModule,
    MatIconModule,
  ],
  exports: [
    FooterContactComponent,
    BrowserAnimationsModule,
    FormsModule
  ],
  declarations: [
    FooterContactComponent
  ] , schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedModule {
}
